import List from '../../../../components/Purchasing/RFQ/Lines/List'
import RFQLinesModal from '../../../../components/Purchasing/RFQ/Lines/RFQLinesModal'
import React, {Fragment} from 'react'

function RFQLines(props) {
  return (
    <Fragment>
      <RFQLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default RFQLines
